import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { IconClose, InformationalScreen, ListCard, ListItem, } from '@adc/parallax-component-library';
import { MainContainer } from 'Components/utility';
import i18n from 'Utilities/i18n';
import mediator from 'Utilities/mediator';
const mapStateToProps = ({ auth, env: { phoneLanguage }, nav: { query } }) => {
    console.log(query.libreAssistConsent);
    return {
        patient: auth.include.patient,
        phoneLanguage,
        displayLibreAssistConsent: !query.libreAssistConsent
            ? true
            : query.libreAssistConsent === 'true',
    };
};
const connector = connect(mapStateToProps);
const ConsentsScreen = ({ patient, phoneLanguage, displayLibreAssistConsent }) => {
    const consentsItems = useMemo(() => {
        const items = [
            {
                text: 'Consents.microcopy.consentsOptions.healthcareCommunications',
                onPress: () => mediator.publish('router:navigate', '/hipaa'),
            },
            {
                text: 'Consents.microcopy.consentsOptions.researchConsent',
                onPress: () => mediator.publish('router:navigate', '/rwe'),
            },
        ];
        if (patient.consents.assist?.at && phoneLanguage === 'en-US' && displayLibreAssistConsent) {
            items.push({
                text: 'Consents.microcopy.consentsOptions.libreAssistDataUse',
                onPress: () => mediator.publish('router:navigate', '/assist'),
            });
        }
        return items;
    }, [patient.consents.assist?.at, phoneLanguage, displayLibreAssistConsent]);
    return (React.createElement(MainContainer, null,
        React.createElement(InformationalScreen, { topNavigationProps: {
                title: i18n.t('Consents.title'),
                buttonStart: {
                    element: React.createElement(IconClose, null),
                    label: 'Consents.title-Pressable',
                    onPress: () => mediator.publish('router:back'),
                },
                testID: 'Consents.title',
            }, testID: "Consents" },
            React.createElement(InformationalScreen.Page, null,
                React.createElement(InformationalScreen.Content, null,
                    React.createElement(ListCard, null, consentsItems.map((item, index) => (React.createElement(ListItem, { key: index.toString(), title: i18n.t(item.text), testID: item.text, onPress: item.onPress })))))))));
};
export default connector(ConsentsScreen);
